"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
// @ts-ignore
const netinfo_1 = __importDefault(require("@react-native-community/netinfo"));
const react_query_1 = require("@tanstack/react-query");
const react_native_1 = require("react-native");
// import TrackPlayer from "react-native-track-player";
const react_redux_1 = require("react-redux");
const AppLoadBranchIO_1 = __importDefault(require("./AppLoadBranchIO"));
const productStore_1 = require("../common/productStore");
const subscription_1 = require("../slices/subscription");
const native_1 = require("@react-navigation/native");
/**
 *
 * @param props
 * @returns
 */
const AppLoadActions = () => {
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    const appUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser);
    (0, react_1.useEffect)(() => {
        react_query_1.onlineManager.setEventListener((setOnline) => {
            return netinfo_1.default.addEventListener((state) => {
                setOnline(!!state.isConnected);
            });
        });
    }, []);
    /**
     * Subscriptions update Actions: revenuecat
     */
    const dispatch = (0, react_redux_1.useDispatch)();
    const getUpdatedSubscriptions = (0, react_1.useCallback)(async () => {
        const activeSubscription = react_native_1.Platform.OS === 'web' ?
            fbUser?.uid && await (0, productStore_1.getActiveSubscriptionWeb)(fbUser.uid) :
            await (0, productStore_1.getActiveSubscription)();
        console.log("GET getUpdatedSubscriptions:", activeSubscription);
        await dispatch((0, subscription_1.setActiveSubscription)(activeSubscription || null));
    }, [fbUser?.uid]);
    const isFocused = (0, native_1.useIsFocused)();
    const updateSubscriptions = (0, react_1.useCallback)(async () => {
        getUpdatedSubscriptions();
    }, [appUser?.id, isFocused, fbUser?.uid]);
    (0, react_1.useEffect)(() => {
        isFocused && fbUser?.uid && updateSubscriptions();
    }, [fbUser?.uid, isFocused]);
    return (0, jsx_runtime_1.jsx)(AppLoadBranchIO_1.default, {});
};
exports.default = AppLoadActions;
